import { ALL_ITEMS } from '@/consts/interface';
import { Nullable } from '@/types/generic';

export {
  convertFilterParamsToString,
  hasEmptyInFilters,
  IN_SEPARATOR_CHAR,
} from '@statsbomb/kitbag-global-football/state';

export const gameEventParams = (gameId: Nullable<number>) => {
  if (!gameId) return undefined;

  return {
    limit: ALL_ITEMS,
    eq: { 'event.game_id': gameId },
    order_by: { 'event.game_time': 'ASC' },
  };
};
